import { useCallback, useState } from 'react';
var incrementParameter = function (num) { return ++num % 1000000; };
var useUpdate = function () {
    var _a = useState(0), setState = _a[1];
    // useCallback with empty deps as we only want to define updateCb once
    return useCallback(function () { return setState(incrementParameter); }, []);
};
export default useUpdate;
